import type { DrillDownLayer, DrillDownPage } from "../types/drillDownPageState.types";

export const getActiveLayer = (page: DrillDownPage): DrillDownLayer => {
  const { layer } = page;
  if (layer.subLayers !== undefined && layer.selectedSubLayerIndex !== undefined) {
    return layer.subLayers[layer.selectedSubLayerIndex] ?? layer;
  }
  return layer;
};
